/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ text: NonNullable<unknown> }} Meeting_Prep_Action_DeleteInputs */



/**
* | output |
* | --- |
* | "Delete: {text}" |
*
* @param {Meeting_Prep_Action_DeleteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_action_delete = /** @type {((inputs: Meeting_Prep_Action_DeleteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Action_DeleteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Verwijderen: ${i?.text}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Supprimer : ${i?.text}`)
	return /** @type {LocalizedString} */ (`Delete: ${i?.text}`)
});